
const NS = 'PlanLayoutService';

export default function PlanLayoutService(SnapConst, SnapService, PlanConst, Group) {
  "ngInject";

  function Layout(s, mode, model) {
    this.s = s;
    this.mode = mode;
    this.model = model;
    this.render();
  }

  Layout.prototype = {
    render: function () {
      //Main container
      this.item = new Group(this.s, 'layout', {
        type: SnapConst.Shapes.Rect,
        w: this.model.size.w,
        h: this.model.size.h
      });
      this.item.buildRootElement();
    },

    getElement: function () {
      return this.item;
    },

    getLabel: function () {
      var label = new Group(this.s, 'label');
      var name = this.s.text(20, 1, this.model.layout.name);
      var closed = this.s.text(0, 1, this.model.serviceLayout.inactive ? '- SECTION CLOSED' : '').addClass('closed');
      label.addElement(name, 'name');
      label.addElement(closed, 'closed');
      _.delay(function () {
        SnapService.place(closed, SnapService.calcBBox(name).w + 22, 0);
      }, 0);
      return label;
    },

    getId: function () {
      return this.model.layout._id;
    },

    isActive: function () {
      return !this.model.serviceLayout.inactive;
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Layout.Type = 'layout';

  Layout.Sizes = {
    Details: {
      w: 310,
      h: 30
    }
  };

  Layout.rootBBox = function () {
    var res = {
      x: this.model.position.x,
      y: this.model.position.y,
      w: this.model.size.w,
      h: this.model.size.h,
      x2: this.model.position.x + this.model.w,
      y2: this.model.position.y + this.model.h
    };
    return res;
  };

  //Used to render section layouts switcher items
  Layout.getDetailItem = function (s, model, active) {
    var g = new Group(s, 'layoutdetail', Layout.Sizes.Details);
    g.buildRootElement();
    if (active) {
      g.getSGroup().addClass('active');
    }
    //Name
    var name = s.text(0, 0, model.name).addClass('name');
    g.addElement(name, 'name');
    SnapService.place(name, 5, 18);
    //Tables
    var tables = s.text(0, 0, ' / ' + _.size(model.tables) + ' tables').addClass('info');
    g.addElement(tables, 'tables');
    SnapService.place(tables, 10 + SnapService.calcBBox(name).w, 18);
    return g;
  };

  return Layout;
}
